export default "__VITE_ASSET__Cu2hRUz7__"